import { createSlice } from '@reduxjs/toolkit'
import { fetchUserDetails, fetchUserSpecificData, addFavouration, getDetailsFavList, getFavourationList, verifyIdentityCard } from '../auth/authAction'
import getUserToken from '../../helpers/tokenValidation'

// initialize userToken from local storage
const userToken = localStorage.getItem('userToken')
  ? getUserToken()
  : null

const initialState = {
  loading: false,
  usersInfo: null,
  userSpecificData: null,
  userFav: null,
  userFavDisplay: null,
  detailsFavList: null,
  idVerifyResult: null,
  userToken,
  error: null,
  success: false,
  cacheTimestamp: null, // Track when data was last fetched
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      state.usersInfo = payload
    },
    setUserToken: (state, action) => {
      state.usersInfo = action.payload
    },
    clearCache: (state) => {
      state.usersInfo = null
      state.userSpecificData = null
      state.cacheTimestamp = null
    }
  },
  extraReducers: {
    // UserDetails
    [fetchUserDetails.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [fetchUserDetails.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.usersInfo = payload
      state.userToken = payload.userToken
      state.success = true
      state.cacheTimestamp = Date.now() // Set cache timestamp
    },
    [fetchUserDetails.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
    },
    [fetchUserSpecificData.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [fetchUserSpecificData.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.userSpecificData = payload
      state.userToken = payload.userToken
      state.success = true
    },
    [fetchUserSpecificData.rejected]: (state, { payload }) => {
      state.loading = false
      state.userSpecificData = payload
      state.error = true
    },
    [addFavouration.pending]: (state) => {
      state.loading = true
    },
    [addFavouration.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.userFav = payload
      state.success = true
    },
    [addFavouration.rejected]: (state, { payload }) => {
      state.loading = false
      state.userFav = payload
      state.error = true
    },
    [getFavourationList.pending]: (state) => {
      state.loading = true
    },
    [getFavourationList.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.userFavDisplay = payload
      state.success = true
    },
    [getFavourationList.rejected]: (state, { payload }) => {
      state.loading = false
      state.userFavDisplay = payload
      state.error = true
    },
    [getDetailsFavList.pending]: (state) => {
      state.loading = true
    },
    [getDetailsFavList.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.detailsFavList = payload
      state.success = true
    },
    [getDetailsFavList.rejected]: (state, { payload }) => {
      state.loading = false
      state.detailsFavList = payload
      state.error = true
    },
    [verifyIdentityCard.pending]: (state) => {
      state.loading = true
      state.idVerifyResult = null
      state.error = null
    },
    [verifyIdentityCard.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.idVerifyResult = payload
      state.success = true
    },
    [verifyIdentityCard.rejected]: (state, { payload }) => {
      state.loading = false
      state.idVerifyResult = payload
      state.error = true
    },
    // Clear state on logout
    ['auth/logout']: (state) => {
      state.usersInfo = null
      state.userSpecificData = null
      state.userFav = null
      state.userFavDisplay = null
      state.detailsFavList = null
      state.idVerifyResult = null
      state.userToken = null
      state.cacheTimestamp = null
      state.success = false
    }
  },
})
// export actions
export const { logout, setCredentials, setUserToken, clearCache } = userSlice.actions
export default userSlice.reducer